var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 31.25h27c.619 0 1.125-.506 1.125-1.125V13.25c0-.619-.506-1.125-1.125-1.125H23.002A5.613 5.613 0 0119.627 11l-2.7-2.025a1.113 1.113 0 00-.675-.225H6.5c-.619 0-1.125.506-1.125 1.125v20.25c0 .619.506 1.125 1.125 1.125zm27 3.375h-27a4.504 4.504 0 01-4.5-4.5V9.875c0-2.482 2.018-4.5 4.5-4.5h9.752c.97 0 1.92.316 2.7.9l2.7 2.025c.387.295.865.45 1.35.45H33.5c2.482 0 4.5 2.018 4.5 4.5v16.875c0 2.482-2.018 4.5-4.5 4.5z",
    fill: "#fff"
  })));
}
export default SvgFolder;